// Adds a trust image below the checkout button in the Opus cart drawer.
//
// The OpusCartChange event fires on cart changes from any template, but the drawer's
// checkout button is not always in the DOM at that moment - on the product page it is
// not, which produced:
//
//   Uncaught TypeError: Cannot read properties of null (reading 'insertAdjacentHTML')
//     at opus-cart-custom.js:3
//
// Guarded below. When the button is absent there is nothing to append to and the handler
// simply does nothing, which is the intended outcome; when it is present the behaviour is
// exactly as before. The image is only inserted once, as the original guard ensured.
window.addEventListener('OpusCartChange', (event) => {
  if (document.querySelector('.opus-extra-image')) return;

  const checkoutButton = document.querySelector('.opus-btn-checkout');
  if (!checkoutButton) return;

  checkoutButton.insertAdjacentHTML(
    "afterend",
    `
      <div class="opus-extra-image" style="width: 100%; display: flex; justify-content: center;">
        <img src="https://cdn.shopify.com/s/files/1/0843/0000/5708/files/Screenshot_2025-02-17_at_15.02.21-removebg-preview.png?v=1739804033" alt="Extra Image" style="max-width: 320px; height: auto; margin-top: 10px;">
      </div>`
  );
});
